import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import { Modal, Button, Form } from "react-bootstrap";
import bannerSettingService from "app/services/bannerSettingService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { Helmet } from "react-helmet";

import Tooltip from "rc-tooltip";

import paginationFactory from "react-bootstrap-table2-paginator";
import {
  getSystem,
  addSystem,
  editSystem,
  deleteSystem,
} from "app/services/SystemServices";
import { NotificationManager } from "react-notifications";
import usePagePermission from "app/hooks/usePagePermission";

const Services = () => {
  const { canAdd, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canEdit, canDelete });

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const loadBannerService = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getSystem(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadBannerService();
  }, []);

  const saveSystemStatus = async (row, e) => {
    const item = {
      id: row.id,
      module: row.module,
      serviceName: row.serviceName,
      serviceDescription: row.serviceDescription,
      isActive: e.target.checked,
    };

    const result = await editSystem(item);
    if (result.status === "Success") {
      NotificationManager.success(result.message, "Success", 5000);
    } else {
      NotificationManager.error(result.message, "Error", 5000);
    }

    loadBannerService();
  };

  const actionFormatter = (cell, row) => {
    return (
      <div
        className=" d-flex justify-content-center"
        style={{ cursor: "pointer" }}
      >
        <Tooltip
          placement="left"
          overlay={row.isActive ? "Click to  Inactive" : "Click to  Active"}
        >
          <span>
            <Form.Check
              type="switch"
              id={`custom-switch${row.id}`}
              checked={row.isActive}
              onChange={(e) => saveSystemStatus(row, e)}
            />
          </span>
        </Tooltip>
      </div>
    );
  };

  const columns = [
    {
      dataField: "serviceName",
      text: "Service Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
    },
    {
      dataField: "serviceDescription",
      text: "Service Description",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    setLoading(true);

    setTimeout(async () => {
      await loadBannerService();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>System Services</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "System Services" }]}></Breadcrumb>

      <div>
        <BootstrapTable
          hover
          remote
          keyField="id"
          data={data}
          columns={
            canEdit ? columns : columns.filter((x) => x.text !== "Action")
          }
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
};

export default Services;
